import { replaceRouteParams } from '../../helpers/url'

import { ROUTE_PARAMS, ROUTES } from '../../constants/routes'
import { PROVIDER_TO_PLATFORMS } from '../../constants/selectLists/platformList'

export const createLineItemSummaryPageLink = (item, createItemLinkExtraParams = {}) => {
  const { id, provider } = item
  return replaceRouteParams(ROUTES.lineItemsSummary, {
    line_item_id: id,
    [ROUTE_PARAMS.platform]: PROVIDER_TO_PLATFORMS[provider],
    ...createItemLinkExtraParams
  })
}
